<script>
import firebase from 'firebase'
import { mapActions } from 'vuex'
import { emailRule, passwordRule } from '../../helpers/validationRules'

export default {
  name: 'ActionUrl',
  data() {
    return {
      mode: '',
      oobCode: '',
      apiKey: '',
      email: null,
      error: null,
      success: null,
      emailRule,
      password: null,
      showPassword: false,
      passwordRule
    }
  },

  created() {
    this.mode = this.$route.query['mode']
    this.oobCode = this.$route.query['oobCode']
    this.apiKey = this.$route.query['apiKey']

    // Get email from Firebase using the oobCode
    if (this.oobCode && this.mode === 'resetPassword') {
      firebase
        .auth()
        .verifyPasswordResetCode(this.oobCode)
        .then(email => {
          this.email = email
        })
        .catch(error => {
          this.error = `Invalid or expired reset link: ${error.message}`
          this.$notify({
            type: 'error',
            group: 'action',
            title: this.error
          })
        })
    }
  },
  methods: {
    ...mapActions(['login']),
    resetPassword() {
      if (this.email && this.password) {
        firebase
          .auth()
          .confirmPasswordReset(this.oobCode.toString(), this.password)
          .then(() => {
            this.success =
              'Password reset is successful, please login with your new password'
            this.error = null
            // Update successful.
            this.$notify({
              type: 'success',
              group: 'action',
              title: this.success
            })

            // Redirect to login after 2 seconds
            setTimeout(() => {
              this.$router.push('/login')
            }, 2000)
          })
          .catch(error => {
            this.success = null
            this.error = `Sorry an error has occurred, ${error.message}`
            this.$notify({
              type: 'error',
              group: 'action',
              title: this.error
            })
          })
      } else {
        this.error = 'All fields are required'
        this.success = null

        this.$notify({
          type: 'error',
          group: 'action',
          title: this.error,
          position: 'top right'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  max-width: 400px;
  margin-top: 60px;
  h2 {
    font-size: 2.4em;
  }
  .field {
    margin-bottom: 16px;
  }
}
</style>

<template>
  <v-card :v-if="mode === 'resetPassword'" width="400" class="mx-auto mt-16">
    <v-card-title>
      <h1 class="display-1">Password Reset</h1>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          name="email"
          label="Email"
          v-model="email"
          prepend-icon="mdi-email"
          :rules="emailRule"
          required
        />
        <v-text-field
          name="password"
          label="Password"
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          prepend-icon="mdi-lock"
          @click:append="showPassword = !showPassword"
          :rules="passwordRule"
          required
        />
        <v-divider class="my-3"></v-divider>
        <p v-if="success" class="my-3 green--text center">{{ success }}</p>
        <p v-if="error" class="my-3 red--text center">{{ error }}</p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="resetPassword" color="primary">Reset Password</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
